import { OODocuments } from '../interfaces';

import { OOControlModel } from './ControlModel';
import { OODocumentPartModel } from './DocumentPartModel';
import { OOUserDocumentModel } from './UserDocumentModel';

export enum SDKModeEnum {
  AUTOCAPTURE = 'autocapture',
  PAPERCAPTURE = 'papercapture',
}

interface ConstructorParams {
  name: OODocuments;
  header: string;
  label: string;
  description: string;
  isMandatory: boolean;
  controls: OOControlModel[];
  parts: OODocumentPartModel[];
  userDocument: OOUserDocumentModel;
  isDisable?: boolean;
  reUpload?: boolean;
  dcDocumentType?: string;
  dcAdditionalDocumentType?: string;
  dcAllowedDocument?: any;
  sdkMode?: SDKModeEnum;
}

export class OODocumentModel {
  public name: OODocuments;
  public header: string;
  public label: string;
  public description: string;
  public isMandatory: boolean;
  public controls: OOControlModel[];
  public parts: OODocumentPartModel[];
  public userDocument: OOUserDocumentModel;
  public dcDocumentType?: string;
  public dcAdditionalDocumentType?: string;
  public dcAllowedDocument?: any;
  public sdkMode?: SDKModeEnum;
  isDisable?: boolean;
  reUpload?: boolean;

  constructor(obj: ConstructorParams) {
    const { name, header, label, description, isMandatory, controls, parts, userDocument, isDisable, reUpload } = obj;
    this.name = name;
    this.header = header;
    this.label = label;
    this.description = description;
    this.isMandatory = isMandatory;
    this.controls = controls;
    this.parts = parts;
    this.userDocument = userDocument;
    this.isDisable = isDisable;
    this.reUpload = reUpload;
    this.dcDocumentType = obj?.dcDocumentType;
    this.dcAdditionalDocumentType = obj?.dcAdditionalDocumentType;
    this.dcAllowedDocument = obj?.dcAllowedDocument;
    this.sdkMode = obj?.sdkMode;
  }

  public static fromJson(json: any) {
    const { name, header, label, description, isMandatory, isDisable, reUpload } = json;
    const controls = (json.controls || []).map((control: any) => OOControlModel.fromJson(control));
    const parts = (json.parts || []).map((part: any) => OODocumentPartModel.fromJson(part));
    const userDocument = json.userDocument;
    return new OODocumentModel({
      name,
      header,
      label,
      description,
      isMandatory,
      controls,
      parts,
      userDocument,
      isDisable,
      reUpload,
      dcDocumentType: json?.dcDocumentType,
      dcAdditionalDocumentType: json?.dcAdditionalDocumentType,
      dcAllowedDocument: json?.dcAllowedDocument,
      sdkMode: json?.sdkMode,
    });
  }
}
